<template>
  <div>
    <h1>Financeiro da Excursão</h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn text to="/grouptrips">
            <v-icon>view_list</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="newAccount" text><v-icon>add</v-icon> Novo</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-tabs
            centered
            background-color="primary"
            dark
            slider-color="primary"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>Despesas</v-tab>
            <v-tab ripple>Receitas</v-tab>
            <v-tab-item>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="payable"
                  class="elevation-1"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="warning" icon="warning"
                      >Nenhum registro</v-alert
                    >
                  </template>

                  <template slot="item" slot-scope="props">
                    <tr>
                      <td>
                        <v-btn
                          small
                          text
                          icon
                          @click="confirmDeletePayable(props.item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </td>
                      <td>{{ props.item.date | moment("L") }}</td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.amount | money }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="receivable"
                  class="elevation-1"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="warning" icon="warning"
                      >Nenhum registro</v-alert
                    >
                  </template>

                  <template slot="item" slot-scope="props">
                    <tr>
                      <td>
                        <v-btn
                          small
                          text
                          icon
                          @click="confirmDeleteReceivable(props.item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </td>
                      <td>{{ props.item.date | moment("L") }}</td>
                      <td>{{ props.item.description }}</td>
                      <td>{{ props.item.amount | money }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="newAccountForm.visible" persistent max-width="800px">
      <v-card>
        <v-card-title class="headline">Nova Conta</v-card-title>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md2>
              <DatePicker
                name="newAccountDate"
                label="Data"
                id="newAccountDate"
                v-model="newAccountForm.account.date"
                required
              />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex md3>
              <MoneyInput
                name="newAccountAmount"
                label="Valor"
                id="newAccountAmount"
                v-model="newAccountForm.account.amount"
              ></MoneyInput>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md2>
              <v-select
                :items="newAccountForm.accountTypes"
                item-value="id"
                item-text="text"
                v-model="newAccountForm.type"
                label="Tipo"
              ></v-select>
            </v-flex>
            <v-flex md10>
              <v-text-field
                name="newAccountDescription"
                label="Descrição"
                id="newAccountDescription"
                v-model="newAccountForm.account.description"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" text @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      ref="executingStatusCard"
      progressMessage="Operação em progresso"
      successMessage="Pronto"
      errorMessage="Falha ao executar operação"
    />
    <ConfirmDialog
      id="confirmDeletePayableDialog"
      ref="confirmDeletePayableDialog"
      title="Excluir Registro"
      :message="
        `Deseja realmente excluir a despesa: ${this.selectedPayable.description}?`
      "
      yes-button="Sim"
      no-button="Não"
      @confirm="this.deletePayable"
    />
    <ConfirmDialog
      id="confirmDeleteReceivableDialog"
      ref="confirmDeleteReceivableDialog"
      title="Excluir Registro"
      :message="
        `Deseja realmente excluir a conta a receita: ${this.selectedReceivable.description}?`
      "
      yes-button="Sim"
      no-button="Não"
      @confirm="this.deleteReceivable"
    />
  </div>
</template>
<script>
import api from "@/api";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import DatePicker from "@/components/Shared/DatePicker";
import MoneyInput from "@/components/Shared/MoneyInput";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "group-trip-accounts",
  components: {
    ConfirmDialog,
    DatePicker,
    MoneyInput,
    OperationStatusCard
  },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "id",
          sortable: false,
          width: 60
        },
        {
          text: "Data",
          value: "date",
          sortable: false,
          width: 100
        },
        {
          text: "Descrição",
          value: "description",
          sortable: false
        },
        {
          text: "Valor",
          value: "amount",
          sortable: false,
          width: 150
        }
      ],
      newAccountForm: {
        visible: false,
        accountTypes: [
          { id: "P", text: "Despesa" },
          { id: "R", text: "Receita" }
        ],
        type: "P",
        account: {
          date: new Date(),
          amount: 0,
          description: ""
        }
      },
      payable: [],
      selectedPayable: {},
      receivable: [],
      selectedReceivable: {}
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    confirmDeletePayable(account) {
      if (account) {
        this.selectedPayable = account;
        this.$refs.confirmDeletePayableDialog.show();
      }
    },
    deletePayable() {
      this.$refs.executingStatusCard.show();
      api
        .request(
          "DELETE",
          `/trips/${this.id}/accountsPayable/${this.selectedPayable.id}`
        )
        .then(() => {
          this.$refs.executingStatusCard.succeed();
          this.selectedPayable = {};
          this.fetchPayable();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    fetchPayable() {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/trips/${this.id}/accountsPayable`)
        .then(response => {
          this.payable = response.data.accounts || [];
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    confirmDeleteReceivable(account) {
      if (account) {
        this.selectedReceivable = account;
        this.$refs.confirmDeleteReceivableDialog.show();
      }
    },
    deleteReceivable() {
      this.$refs.executingStatusCard.show();
      api
        .request(
          "DELETE",
          `/trips/${this.id}/accountsReceivable/${this.selectedReceivable.id}`
        )
        .then(() => {
          this.$refs.executingStatusCard.succeed();
          this.selectedReceivable = {};
          this.fetchReceivable();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    fetchReceivable() {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/trips/${this.id}/accountsReceivable`)
        .then(response => {
          this.receivable = response.data.accounts || [];
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    newAccount() {
      this.newAccountForm.visible = true;
      this.newAccountForm.type = "P";
      this.newAccountForm.account = {
        date: new Date(),
        amount: 0,
        description: ""
      };
    },
    cancel() {
      this.newAccountForm.visible = false;
      this.newAccountForm.account = {};
    },
    save() {
      this.$refs.executingStatusCard.show();

      var controller =
        this.newAccountForm.type == "P"
          ? "accountsPayable"
          : "accountsReceivable";

      api
        .request(
          "POST",
          `/trips/${this.id}/${controller}`,
          this.newAccountForm.account
        )
        .then(() => {
          this.$refs.executingStatusCard.succeed();
          this.newAccountForm.visible = false;
          this.newAccountForm.account = {};
          switch (this.newAccountForm.type) {
            case "P":
              this.fetchPayable();
              break;
            case "R":
              this.fetchReceivable();
              break;
          }
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    }
  },
  mounted() {
    if (this.id) {
      this.fetchPayable();
      this.fetchReceivable();
    }
  }
};
</script>
